import { assetUrl } from '../../lib/assetUrl';
import './SplitSection.css';

const DEFAULT_ASPECT_RATIO = '4 / 3';

/**
 * Image beside a column of text. Media is on the left unless `reverse` is set.
 * @param {{
 *   id: string,
 *   image: string,
 *   imageAlt?: string,
 *   title?: string,
 *   eyebrow?: string,
 *   reverse?: boolean,
 *   tinted?: boolean,
 *   mediaFit?: 'cover' | 'contain',
 *   aspectRatio?: string,
 *   children: React.ReactNode,
 * }} props
 */
export default function SplitSection({
  id,
  image,
  imageAlt = '',
  title,
  eyebrow,
  reverse = false,
  tinted = false,
  mediaFit = 'cover',
  aspectRatio = DEFAULT_ASPECT_RATIO,
  children,
}) {
  const sectionClassName = [
    'section',
    'split',
    tinted && 'section--tinted',
    reverse && 'split--reverse',
  ]
    .filter(Boolean)
    .join(' ');

  const frameClassName = mediaFit === 'contain' ? 'media-frame media-frame--contain' : 'media-frame';
  const headingId = title ? `${id}-title` : undefined;

  return (
    <section id={id} className={sectionClassName} aria-labelledby={headingId}>
      <div className="container split__inner">
        <div className="split__media">
          <div className={frameClassName} style={{ aspectRatio }}>
            <img src={assetUrl(image)} alt={imageAlt} loading="lazy" />
          </div>
        </div>
        <div className="split__content">
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          {title && <h2 id={headingId}>{title}</h2>}
          <div className="split__body">{children}</div>
        </div>
      </div>
    </section>
  );
}
